import React, { useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

//CSS
import "./ExportDataComponent.css";

//Components
import InputField from "./inputField";
import Button from "./button";

//Functions and hooks
import { useTranslation } from "react-i18next";

export default function ExportData({ data, className }) {
  const [format, setFormat] = useState("xlsx");
  const [fileName, setFileName] = useState("export");
  const [error, setError] = useState(null);

  const { t } = useTranslation();

  const handleExport = () => {
    setError(null);
    try {
      if (!Array.isArray(data)) {
        throw new Error("Data must be an array of objects");
      }

      // Derive headers and rows
      const headers = data.length > 0 ? Object.keys(data[0]) : [];
      const rows = data.map((rowObj) =>
        headers.map((header) => rowObj[header])
      );
      const filename = `${fileName}.${format}`;

      if (format === "json") {
        const blob = new Blob([JSON.stringify(data, null, 2)], {
          type: "application/json",
        });
        saveAs(blob, filename);
      } else if (format === "csv") {
        const csvRows = [headers.join(",")];
        rows.forEach((r) =>
          csvRows.push(
            r
              .map((val) => {
                if (typeof val === "string" && val.includes(",")) {
                  return `"${val.replace(/"/g, '""')}"`;
                }
                return val;
              })
              .join(",")
          )
        );
        const blob = new Blob([csvRows.join("\n")], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, filename);
      } else {
        // xlsx
        const aoa = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([buf], { type: "application/octet-stream" });
        saveAs(blob, filename);
      }
    } catch (e) {
      console.error(e);
      setError("Export failed: " + e.message);
    }
  };

  const formatOptions = [
    { label: "Excel (.xlsx)", value: "xlsx" },
    { label: "CSV (.csv)", value: "csv" },
    { label: "JSON (.json)", value: "json" },
  ];

  return (
    <div className={"export-container " + className}>
      <h2 className="export-header">{t("Export Data")}</h2>

      <div className="mb-2">
        <InputField
          label={t("Format")}
          type="dropdown"
          options={formatOptions}
          value={format}
          onChange={setFormat}
        />
      </div>

      <div className="mb-2">
        <InputField
          label={t("File Name")}
          placeholder="Enter file name"
          value={fileName}
          onChange={setFileName}
        />
      </div>
      <div className="btn-container w-100% justify-end">
        <Button
          onClick={handleExport}
          btnSize={"btn-small"}
          btnStyle={"btn-positive"}
        >
          {t("Export")}
        </Button>
      </div>

      {error && <div className="mt-2 text-red-600">{error}</div>}
    </div>
  );
}
